(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scopri-i-gioielli"] && !Shopify.designMode) return;
  try {
    

(function () {

  'use strict';


  var roots =
    document.querySelectorAll('[data-scopri-v6]');


  if (!roots.length) {
    return;
  }


  roots.forEach(function (root) {


    if (root.dataset.v6Initialized === 'true') {
      return;
    }


    root.dataset.v6Initialized = 'true';



    /* =============================
       CONFIGURAZIONE
    ============================= */


    var collectionHandle =
      String(
        root.dataset.collection || 'all'
      ).trim();


    if (!collectionHandle) {
      collectionHandle = 'all';
    }


    var perPage =
      parseInt(
        root.dataset.perPage,
        10
      ) || 8;



    var tagMap = {

      ANELLI:
        root.dataset.tagAnelli || 'ANELLI',

      ORECCHINI:
        root.dataset.tagOrecchini || 'ORECCHINI',

      COLLANE:
        root.dataset.tagCollane || 'COLLANE',

      BRACCIALI:
        root.dataset.tagBracciali || 'BRACCIALI',

      OROLOGI:
        root.dataset.tagOrologi || 'OROLOGI'

    };



    /*
      COLLEZIONI UTILIZZATE
      PER "IN EVIDENZA"
    */


    var featuredCollectionMap = {

      TUTTI:
        'gioielli-tutti',

      ANELLI:
        'gioielli-anelli',

      ORECCHINI:
        'gioielli-orecchini',

      COLLANE:
        'gioielli-collane',

      BRACCIALI:
        'gioielli-bracciali',

      OROLOGI:
        'gioielli-orologi'

    };



    /* =============================
       STATO
    ============================= */


    var activeFilter =
      'TUTTI';


    var activeSort =
      'manual';


    var sourceProducts =
      [];


    var visibleProducts =
      [];


    var filteredProducts =
      [];


    var displayed =
      0;


    var hasMore =
      false;


    var isLoading =
      false;


    /*
      Cache ordini "In evidenza"
      per evitare nuovi fetch.
    */

    var featuredOrderCache =
      {};


    /*
      Token per evitare che una richiesta
      vecchia modifichi una categoria nuova.
    */

    var featuredRequestToken =
      0;



    /* =============================
       ELEMENTI
    ============================= */


    var grid =
      root.querySelector(
        '.scopri-v6__grid'
      );


    var loading =
      root.querySelector(
        '.scopri-v6__loading'
      );


    var empty =
      root.querySelector(
        '.scopri-v6__empty'
      );


    var moreWrapper =
      root.querySelector(
        '.scopri-v6__more-wrapper'
      );


    var moreButton =
      root.querySelector(
        '.scopri-v6__more'
      );


    var sortSelect =
      root.querySelector(
        '.scopri-v6__sort'
      );


    var filterButtons =
      root.querySelectorAll(
        '.scopri-v6__filter'
      );


    if (!grid) {
      return;
    }



    /* =============================
       URL SHOPIFY
    ============================= */


    function getBaseUrl() {


      var rootUrl =
        '/';


      if (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) {

        rootUrl =
          window.Shopify.routes.root;

      }


      return String(rootUrl)
        .replace(/\/$/, '');

    }



    function buildUrl(page) {


      return (

        getBaseUrl()

        + '/collections/'

        + encodeURIComponent(
            collectionHandle
          )

        + '/products.json'

        + '?limit=250'

        + '&page='

        + page

      );

    }



    /* =============================
       TESTO
    ============================= */


    function escapeHtml(value) {


      return String(value || '')

        .replace(/&/g, '&amp;')

        .replace(/</g, '&lt;')

        .replace(/>/g, '&gt;')

        .replace(/"/g, '&quot;')

        .replace(/'/g, '&#039;');

    }



    function normalizeTag(value) {


      return String(value || '')

        .trim()

        .toUpperCase();

    }



    /* =============================
       TAG
    ============================= */


    function getTags(product) {


      var tags =
        product.tags || [];


      if (Array.isArray(tags)) {


        return tags.map(
          function (tag) {

            return normalizeTag(tag);

          }
        );

      }


      if (typeof tags === 'string') {


        return tags

          .split(',')

          .map(
            function (tag) {

              return normalizeTag(tag);

            }
          );

      }


      return [];

    }



    function hasTag(
      product,
      requiredTag
    ) {


      var wanted =
        normalizeTag(
          requiredTag
        );


      if (!wanted) {
        return false;
      }


      var tags =
        getTags(product);


      return (
        tags.indexOf(wanted)
        !== -1
      );

    }



    /* =============================
       VARIANTI / PREZZI
    ============================= */


    function getValidVariants(product) {


      var variants =
        product.variants || [];


      return variants.filter(
        function (variant) {


          var price =
            parseFloat(
              variant.price
            );


          return (

            variant.available === true

            &&

            !isNaN(price)

            &&

            price > 0

          );

        }
      );

    }



    function getCheapestValidVariant(product) {


      var variants =
        getValidVariants(product);


      if (!variants.length) {
        return null;
      }


      variants.sort(
        function (a, b) {


          return (

            parseFloat(a.price)

            -

            parseFloat(b.price)

          );

        }
      );


      return variants[0];

    }



    function getMinimumPrice(product) {


      var variant =
        getCheapestValidVariant(
          product
        );


      if (!variant) {
        return Infinity;
      }


      var price =
        parseFloat(
          variant.price
        );


      if (
        isNaN(price) ||
        price <= 0
      ) {

        return Infinity;

      }


      return price;

    }



    function productIsVisible(product) {


      return (
        getCheapestValidVariant(product)
        !== null
      );

    }



    /* =============================
       PREZZO
    ============================= */


    function formatMoney(value) {


      var number =
        parseFloat(value);


      if (
        isNaN(number) ||
        number <= 0
      ) {

        return '';

      }


      return new Intl.NumberFormat(
        'it-IT',
        {
          style: 'currency',
          currency: 'EUR'
        }
      ).format(number);

    }



    /* =============================
       CARD
    ============================= */


    function buildCard(product) {


      var variant =
        getCheapestValidVariant(
          product
        );


      if (!variant) {
        return '';
      }


      var price =
        parseFloat(
          variant.price
        );


      if (
        isNaN(price) ||
        price <= 0
      ) {

        return '';

      }


      var compare =

        variant.compare_at_price

          ? parseFloat(
              variant.compare_at_price
            )

          : null;


      var onSale =

        compare

        &&

        !isNaN(compare)

        &&

        compare > price;


      var title =
        escapeHtml(
          product.title
        );


      var vendor =
        escapeHtml(
          product.vendor
        );


      var productUrl =

        getBaseUrl()

        + '/products/'

        + encodeURIComponent(
            product.handle || ''
          );


      var imageUrl =
        '';


      if (
        product.images &&
        product.images.length &&
        product.images[0] &&
        product.images[0].src
      ) {

        imageUrl =
          product.images[0].src;

      }


      var imageHtml =
        '';


      if (imageUrl) {


        imageHtml =

          '<img'

          + ' src="'
          + escapeHtml(imageUrl)
          + '"'

          + ' alt="'
          + title
          + '"'

          + ' loading="lazy"'

          + ' width="600"'

          + ' height="600"'

          + '>';


      } else {


        imageHtml =

          '<div class="scopri-v6__no-image"></div>';

      }


      var badgeHtml =

        onSale

          ? '<span class="scopri-v6__badge">SALE</span>'

          : '';


      var priceHtml =
        '';


      if (onSale) {


        priceHtml =

          '<span class="scopri-v6__price scopri-v6__price--sale">'

          + formatMoney(price)

          + '</span>'

          +

          '<span class="scopri-v6__price scopri-v6__price--compare">'

          + formatMoney(compare)

          + '</span>';


      } else {


        priceHtml =

          '<span class="scopri-v6__price">'

          + formatMoney(price)

          + '</span>';

      }


      return (

        '<div class="scopri-v6__card-wrapper">'

        +

        '<a'
        + ' class="scopri-v6__card-link"'
        + ' href="' + escapeHtml(productUrl) + '"'
        + ' aria-label="' + title + '"'
        + '>'

        +

        '<div class="scopri-v6__card">'

        +

        '<div class="scopri-v6__image">'
        + imageHtml
        + badgeHtml
        + '</div>'

        +

        '<div class="scopri-v6__info">'

        +

        '<p class="scopri-v6__vendor">'
        + vendor
        + '</p>'

        +

        '<h3 class="scopri-v6__product-title">'
        + title
        + '</h3>'

        +

        '<div class="scopri-v6__price-wrapper">'
        + priceHtml
        + '</div>'

        +

        '</div>'

        +

        '</div>'

        +

        '</a>'

        +

        '</div>'

      );

    }



    /* =============================
       FILTRO
    ============================= */


    function applyFilter() {


      if (
        activeFilter === 'TUTTI'
      ) {


        filteredProducts =
          visibleProducts.slice();


        return;

      }


      var requiredTag =
        tagMap[activeFilter];


      filteredProducts =

        visibleProducts.filter(
          function (product) {


            return hasTag(
              product,
              requiredTag
            );

          }
        );

    }



    /* =============================
       ORDINE "IN EVIDENZA"
       PER TUTTE LE CATEGORIE
    ============================= */


    function sortByFeaturedOrder(
      orderMap
    ) {


      filteredProducts.sort(
        function (a, b) {


          var hasA =

            Object.prototype
              .hasOwnProperty.call(
                orderMap,
                a.handle
              );


          var hasB =

            Object.prototype
              .hasOwnProperty.call(
                orderMap,
                b.handle
              );


          var indexA =

            hasA

              ? orderMap[
                  a.handle
                ]

              : 999999;


          var indexB =

            hasB

              ? orderMap[
                  b.handle
                ]

              : 999999;



          /*
            Se nessuno dei due è presente
            nella relativa collezione,
            mantieni l'ordine originale.
          */


          if (
            indexA === 999999 &&
            indexB === 999999
          ) {


            return (

              a._scopriV6OriginalIndex

              -

              b._scopriV6OriginalIndex

            );

          }


          return indexA - indexB;

        }
      );

    }



    function loadFeaturedOrder() {


      var currentFilter =
        activeFilter;


      var collectionForFeatured =
        featuredCollectionMap[
          currentFilter
        ];


      if (!collectionForFeatured) {


        applySort();

        render(true);

        return Promise.resolve();

      }



      /*
        Nuovo token per questa richiesta.
      */


      var myToken =
        ++featuredRequestToken;



      /*
        Ordine già in cache.
      */


      if (
        featuredOrderCache[
          collectionForFeatured
        ]
      ) {


        if (
          myToken !==
          featuredRequestToken
        ) {

          return Promise.resolve();

        }


        sortByFeaturedOrder(

          featuredOrderCache[
            collectionForFeatured
          ]

        );


        render(true);


        return Promise.resolve();

      }



      var page =
        1;


      var orderedHandles =
        [];



      function loadPage() {


        var url =

          getBaseUrl()

          + '/collections/'

          + encodeURIComponent(
              collectionForFeatured
            )

          + '/products.json'

          + '?limit=250'

          + '&page='

          + page;



        return fetch(
          url,
          {
            headers: {
              'Accept':
                'application/json'
            }
          }
        )


        .then(
          function (response) {


            if (!response.ok) {


              throw new Error(
                'HTTP '
                + response.status
              );

            }


            return response.json();

          }
        )


        .then(
          function (data) {


            if (
              myToken !==
              featuredRequestToken
            ) {

              return;

            }


            var products =
              data.products || [];


            products.forEach(
              function (product) {


                orderedHandles.push(
                  product.handle
                );

              }
            );


            if (
              products.length === 250
            ) {


              page += 1;


              return loadPage();

            }

          }
        );

      }



      return loadPage()


        .then(
          function () {


            if (
              myToken !==
              featuredRequestToken
            ) {

              return;

            }


            /*
              Nel frattempo l'utente
              potrebbe aver cambiato categoria.
            */


            if (
              activeFilter !==
              currentFilter
            ) {

              return;

            }


            if (
              activeSort !==
              'manual'
            ) {

              return;

            }


            var orderMap =
              {};


            orderedHandles.forEach(
              function (
                handle,
                index
              ) {


                orderMap[handle] =
                  index;

              }
            );


            featuredOrderCache[
              collectionForFeatured
            ] = orderMap;


            sortByFeaturedOrder(
              orderMap
            );


            render(true);

          }
        )


        .catch(
          function (error) {


            if (
              myToken !==
              featuredRequestToken
            ) {

              return;

            }


            console.error(

              '[SCOPRI V6] Errore ordine In evidenza:',

              error

            );


            /*
              Se la collezione non viene trovata,
              usa l'ordine originale.
            */


            filteredProducts.sort(
              function (a, b) {


                return (

                  a._scopriV6OriginalIndex

                  -

                  b._scopriV6OriginalIndex

                );

              }
            );


            render(true);

          }
        );

    }



    /* =============================
       ALTRI ORDINAMENTI
    ============================= */


    function applySort() {


      if (
        activeSort ===
        'price-ascending'
      ) {


        filteredProducts.sort(
          function (a, b) {


            return (

              getMinimumPrice(a)

              -

              getMinimumPrice(b)

            );

          }
        );


        return;

      }


      if (
        activeSort ===
        'price-descending'
      ) {


        filteredProducts.sort(
          function (a, b) {


            return (

              getMinimumPrice(b)

              -

              getMinimumPrice(a)

            );

          }
        );


        return;

      }


      if (
        activeSort ===
        'created-descending'
      ) {


        filteredProducts.sort(
          function (a, b) {


            var dateA =
              new Date(
                a.published_at || 0
              );


            var dateB =
              new Date(
                b.published_at || 0
              );


            return dateB - dateA;

          }
        );


        return;

      }


      /*
        Fallback.
        In evidenza viene gestito
        separatamente.
      */


      filteredProducts.sort(
        function (a, b) {


          return (

            a._scopriV6OriginalIndex

            -

            b._scopriV6OriginalIndex

          );

        }
      );

    }



    /* =============================
       RENDER
    ============================= */


    function render(reset) {


      if (reset) {


        grid.innerHTML =
          '';


        displayed =
          0;

      }


      if (!filteredProducts.length) {


        empty.style.display =
          'block';


        moreWrapper.style.display =
          'none';


        return;

      }


      empty.style.display =
        'none';


      var nextProducts =

        filteredProducts.slice(

          displayed,

          displayed + perPage

        );


      var html =
        '';


      nextProducts.forEach(
        function (product) {


          html +=
            buildCard(product);

        }
      );


      grid.insertAdjacentHTML(
        'beforeend',
        html
      );


      displayed +=
        nextProducts.length;


      hasMore =

        displayed

        <

        filteredProducts.length;


      moreWrapper.style.display =

        hasMore

          ? 'block'

          : 'none';

    }



    /* =============================
       REFRESH
    ============================= */


    function refresh() {


      applyFilter();


      /*
        IN EVIDENZA:

        qualunque categoria sia selezionata,
        legge l'ordine della relativa
        collezione Shopify.
      */


      if (
        activeSort === 'manual'
      ) {


        loadFeaturedOrder();


        return;

      }


      /*
        Tutti gli altri ordinamenti.
      */


      applySort();


      render(true);

    }



    /* =============================
       LOADING
    ============================= */


    function setLoading(state) {


      isLoading =
        state;


      if (loading) {


        loading.classList.toggle(
          'is-visible',
          state
        );

      }


      if (moreButton) {


        moreButton.disabled =
          state;

      }

    }



    /* =============================
       CARICAMENTO CATALOGO
    ============================= */


    function fetchAllProducts() {


      var page =
        1;


      sourceProducts =
        [];


      visibleProducts =
        [];


      setLoading(true);



      function loadPage() {


        return fetch(
          buildUrl(page),
          {
            method: 'GET',
            headers: {
              'Accept':
                'application/json'
            }
          }
        )


        .then(
          function (response) {


            if (!response.ok) {


              throw new Error(
                'Errore HTTP '
                + response.status
              );

            }


            return response.json();

          }
        )


        .then(
          function (data) {


            var products =
              data.products || [];


            products.forEach(
              function (product) {


                product._scopriV6OriginalIndex =
                  sourceProducts.length;


                sourceProducts.push(
                  product
                );

              }
            );


            if (
              products.length === 250
            ) {


              page += 1;


              return loadPage();

            }

          }
        );

      }



      return loadPage()


        .then(
          function () {


            /*
              Elimina esauriti
              e prezzo zero.
            */


            visibleProducts =

              sourceProducts.filter(
                function (product) {


                  return productIsVisible(
                    product
                  );

                }
              );


            visibleProducts =

              visibleProducts.filter(
                function (product) {


                  return (

                    getMinimumPrice(
                      product
                    )

                    > 0

                  );

                }
              );


            refresh();

          }
        )


        .catch(
          function (error) {


            console.error(

              '[SCOPRI V6] ERRORE:',

              error

            );


            grid.innerHTML =
              '';


            empty.style.display =
              'block';


            moreWrapper.style.display =
              'none';

          }
        )


        .finally(
          function () {


            setLoading(false);

          }
        );

    }



    /* =============================
       CLICK CATEGORIE
    ============================= */


    filterButtons.forEach(
      function (button) {


        button.addEventListener(
          'click',
          function () {


            var newFilter =

              String(
                button.dataset.v6Filter || ''
              )

              .toUpperCase();


            if (!newFilter) {
              return;
            }


            if (
              newFilter === activeFilter
            ) {

              return;

            }


            /*
              Annulla eventuale vecchia
              richiesta "In evidenza".
            */


            featuredRequestToken += 1;


            filterButtons.forEach(
              function (item) {


                item.classList.remove(
                  'is-active'
                );


                item.setAttribute(
                  'aria-selected',
                  'false'
                );

              }
            );


            button.classList.add(
              'is-active'
            );


            button.setAttribute(
              'aria-selected',
              'true'
            );


            activeFilter =
              newFilter;


            refresh();

          }
        );

      }
    );



    /* =============================
       CAMBIO ORDINAMENTO
    ============================= */


    if (sortSelect) {


      sortSelect.addEventListener(
        'change',
        function () {


          activeSort =
            this.value || 'manual';


          /*
            Annulla eventuale richiesta
            precedente "In evidenza".
          */


          featuredRequestToken += 1;


          if (isLoading) {
            return;
          }


          /*
            IN EVIDENZA:
            per TUTTE le categorie.
          */


          if (
            activeSort === 'manual'
          ) {


            loadFeaturedOrder();


            return;

          }


          /*
            Prezzo / Novità.
          */


          applySort();


          render(true);

        }
      );

    }



    /* =============================
       VEDI ALTRI
    ============================= */


    if (moreButton) {


      moreButton.addEventListener(
        'click',
        function () {


          if (
            isLoading ||
            !hasMore
          ) {

            return;

          }


          render(false);

        }
      );

    }



    /* =============================
       AVVIO
    ============================= */


    fetchAllProducts();


  });


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"]) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.scopri-gioielli');

  sections.forEach(function (section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    // --- Configurazione ---
    const collectionHandle = section.dataset.collection;
    const perPage = parseInt(section.dataset.perPage, 10) || 8;

    const tagMap = {
      ANELLI: section.dataset.tagAnelli,
      ORECCHINI: section.dataset.tagOrecchini,
      COLLANE: section.dataset.tagCollane,
      BRACCIALI: section.dataset.tagBracciali
    };

    // --- Stato ---
    let allProducts = [];
    let filteredProducts = [];
    let visibleCount = perPage;
    let activeFilter = 'TUTTI';
    let activeSort = 'manual';

    // --- Elementi DOM ---
    const grid = section.querySelector('.scopri-gioielli__grid');
    const loadMoreWrap = section.querySelector('.scopri-gioielli__load-more-wrapper');
    const loadMoreBtn = section.querySelector('.scopri-gioielli__load-more-btn');
    const emptyMsg = section.querySelector('.scopri-gioielli__empty');
    const loadingEl = section.querySelector('.scopri-gioielli__loading');
    const sortSelect = section.querySelector('.scopri-gioielli__sort-select');
    const filterBtns = section.querySelectorAll('.scopri-gioielli__filter-btn');

    // --- URL Shopify local-aware ---
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    // --- Escape HTML ---
    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    // --- Formattazione prezzo ---
    function formatMoney(value) {
      const number = Number(value);

      if (!Number.isFinite(number)) {
        return '';
      }

      try {
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR'
        }).format(number);
      } catch (e) {
        return '€ ' + number.toFixed(2).replace('.', ',');
      }
    }

    // --- Recupera tutti i prezzi validi delle varianti ---
    function getVariantPrices(product) {
      if (!product || !Array.isArray(product.variants)) {
        return [];
      }

      return product.variants
        .map(function (variant) {
          return parseFloat(variant.price);
        })
        .filter(function (price) {
          return Number.isFinite(price);
        });
    }

    // --- Prezzo minimo reale del prodotto ---
    function getProductPrice(product) {
      const prices = getVariantPrices(product);

      if (prices.length === 0) {
        return Infinity;
      }

      return Math.min.apply(null, prices);
    }

    // --- Variante col prezzo minimo ---
    function getLowestPriceVariant(product) {
      if (!product || !Array.isArray(product.variants)) {
        return null;
      }

      let lowestVariant = null;
      let lowestPrice = Infinity;

      product.variants.forEach(function (variant) {
        const price = parseFloat(variant.price);

        if (Number.isFinite(price) && price < lowestPrice) {
          lowestPrice = price;
          lowestVariant = variant;
        }
      });

      return lowestVariant;
    }

    // --- Fetch prodotti collezione ---
    async function fetchAllProducts(handle) {
      const products = [];
      let page = 1;
      const limit = 250;

      while (true) {
        const url =
          root +
          'collections/' +
          encodeURIComponent(handle) +
          '/products.json?limit=' +
          limit +
          '&page=' +
          page;

        const response = await fetch(url, {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(
            'Errore caricamento prodotti: HTTP ' + response.status
          );
        }

        const data = await response.json();

        if (!data.products || data.products.length === 0) {
          break;
        }

        products.push.apply(products, data.products);

        if (data.products.length < limit) {
          break;
        }

        page += 1;

        // Sicurezza anti-loop infinito
        if (page > 50) {
          break;
        }
      }

      return products;
    }

    // --- Filtro per tag ---
    function applyFilter(products, filter) {
      if (filter === 'TUTTI') {
        return products.slice();
      }

      const requiredTag = tagMap[filter];

      if (!requiredTag) {
        return products.slice();
      }

      const targetTag = requiredTag.trim().toLowerCase();

      return products.filter(function (product) {
        let tags = [];

        if (Array.isArray(product.tags)) {
          tags = product.tags;
        } else if (typeof product.tags === 'string') {
          tags = product.tags.split(',');
        }

        return tags.some(function (tag) {
          return String(tag).trim().toLowerCase() === targetTag;
        });
      });
    }

    // --- Ordinamento corretto ---
    function applySort(products, sort) {
      const arr = products.slice();

      switch (sort) {
        case 'price-ascending':
          return arr.sort(function (a, b) {
            const priceA = getProductPrice(a);
            const priceB = getProductPrice(b);

            return priceA - priceB;
          });

        case 'price-descending':
          return arr.sort(function (a, b) {
            const priceA = getProductPrice(a);
            const priceB = getProductPrice(b);

            // Gestisce prodotti senza prezzo valido
            if (!Number.isFinite(priceA) && !Number.isFinite(priceB)) {
              return 0;
            }

            if (!Number.isFinite(priceA)) {
              return 1;
            }

            if (!Number.isFinite(priceB)) {
              return -1;
            }

            return priceB - priceA;
          });

        case 'created-descending':
          return arr.sort(function (a, b) {
            const dateA = new Date(
              a.published_at || a.created_at || 0
            ).getTime();

            const dateB = new Date(
              b.published_at || b.created_at || 0
            ).getTime();

            return dateB - dateA;
          });

        default:
          // Mantiene l'ordine originale della collezione
          return arr;
      }
    }

    // --- Immagine ---
    function getProductImage(product) {
      if (
        product.images &&
        Array.isArray(product.images) &&
        product.images.length > 0
      ) {
        const firstImage = product.images[0];

        if (typeof firstImage === 'string') {
          return firstImage;
        }

        if (firstImage.src) {
          return firstImage.src;
        }
      }

      if (product.image && product.image.src) {
        return product.image.src;
      }

      return '';
    }

    // --- Costruisce card ---
    function buildCard(product) {
      const lowestVariant = getLowestPriceVariant(product);

      const price = lowestVariant
        ? parseFloat(lowestVariant.price)
        : getProductPrice(product);

      const compareAtPrice =
        lowestVariant && lowestVariant.compare_at_price
          ? parseFloat(lowestVariant.compare_at_price)
          : 0;

      const onSale =
        Number.isFinite(compareAtPrice) &&
        Number.isFinite(price) &&
        compareAtPrice > price;

      const image = getProductImage(product);
      const title = escapeHtml(product.title);
      const vendor = escapeHtml(product.vendor);
      const handle = encodeURIComponent(product.handle);

      const productUrl = root + 'products/' + handle;

      let imageHtml = '';

      if (image) {
        imageHtml =
          '<img ' +
          'src="' +
          escapeHtml(image) +
          '" ' +
          'alt="' +
          title +
          '" ' +
          'loading="lazy" ' +
          'width="600" ' +
          'height="600">';
      } else {
        imageHtml =
          '<div class="scopri-gioielli__no-image"></div>';
      }

      const badgeHtml = onSale
        ? '<span class="scopri-gioielli__badge">SALE</span>'
        : '';

      let priceHtml = '';

      if (Number.isFinite(price)) {
        if (onSale) {
          priceHtml =
            '<span class="scopri-gioielli__price scopri-gioielli__price--sale">' +
            formatMoney(price) +
            '</span>' +
            '<span class="scopri-gioielli__price scopri-gioielli__price--compare">' +
            formatMoney(compareAtPrice) +
            '</span>';
        } else {
          priceHtml =
            '<span class="scopri-gioielli__price">' +
            formatMoney(price) +
            '</span>';
        }
      }

      return (
        '<div class="scopri-gioielli__card-wrapper">' +
          '<a href="' +
          productUrl +
          '" class="scopri-gioielli__card-link" aria-label="' +
          title +
          '">' +

            '<div class="scopri-gioielli__card product-card__content product-grid__card">' +

              '<div class="scopri-gioielli__card-image">' +
                imageHtml +
                badgeHtml +
              '</div>' +

              '<div class="scopri-gioielli__card-info">' +

                '<p class="scopri-gioielli__card-vendor">' +
                  vendor +
                '</p>' +

                '<h3 class="scopri-gioielli__card-title">' +
                  title +
                '</h3>' +

                '<div class="scopri-gioielli__card-price">' +
                  priceHtml +
                '</div>' +

              '</div>' +

            '</div>' +

          '</a>' +
        '</div>'
      );
    }

    // --- Render griglia ---
    function render() {
      const visibleProducts = filteredProducts.slice(
        0,
        visibleCount
      );

      if (filteredProducts.length === 0) {
        grid.innerHTML = '';

        if (emptyMsg) {
          emptyMsg.style.display = 'block';
        }

        if (loadMoreWrap) {
          loadMoreWrap.style.display = 'none';
        }

        return;
      }

      if (emptyMsg) {
        emptyMsg.style.display = 'none';
      }

      grid.innerHTML = visibleProducts
        .map(function (product) {
          return buildCard(product);
        })
        .join('');

      if (loadMoreWrap) {
        loadMoreWrap.style.display =
          visibleCount < filteredProducts.length
            ? 'block'
            : 'none';
      }
    }

    // --- Aggiorna filtro e ordinamento ---
    function updateProducts() {
      visibleCount = perPage;

      const categoryProducts = applyFilter(
        allProducts,
        activeFilter
      );

      filteredProducts = applySort(
        categoryProducts,
        activeSort
      );

      render();
    }

    // --- Loading ---
    function setLoading(state) {
      if (loadingEl) {
        loadingEl.classList.toggle(
          'is-visible',
          state
        );
      }

      if (grid) {
        grid.style.opacity = state ? '0.3' : '';
      }
    }

    // --- Init ---
    async function init() {
      if (!collectionHandle) {
        console.warn(
          '[SCOPRI I GIOIELLI] Seleziona una collezione nelle impostazioni della sezione.'
        );
        return;
      }

      setLoading(true);

      try {
        allProducts = await fetchAllProducts(
          collectionHandle
        );

        updateProducts();
      } catch (error) {
        console.error(
          '[SCOPRI I GIOIELLI]',
          error
        );

        if (grid) {
          grid.innerHTML =
            '<p class="scopri-gioielli__empty">' +
            'Impossibile caricare i prodotti.' +
            '</p>';
        }
      } finally {
        setLoading(false);
      }
    }

    // --- Click filtri ---
    filterBtns.forEach(function (button) {
      button.addEventListener('click', function () {
        filterBtns.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute(
            'aria-selected',
            'false'
          );
        });

        button.classList.add('is-active');
        button.setAttribute(
          'aria-selected',
          'true'
        );

        activeFilter =
          button.dataset.filter || 'TUTTI';

        updateProducts();
      });
    });

    // --- Ordinamento ---
    if (sortSelect) {
      sortSelect.addEventListener(
        'change',
        function () {
          activeSort = this.value;

          updateProducts();
        }
      );
    }

    // --- Vedi altri ---
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener(
        'click',
        function () {
          visibleCount += perPage;

          render();
        }
      );
    }

    // --- Avvio ---
    init();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
